import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { SectionTabsHeader } from '@app/components/core';
import { insightsExportsPath, insightsOverviewPath } from '@app/constants/url';
import { useOrganizationId } from '@app/utils/hooks';

/**
 * The header both Insights tabs sit under. Rendered by each tab rather than by a shared layout route, the way
 * Members does it — the active tab comes from the URL, so a link opens the right one and a refresh stays put.
 */
export const InsightsTabs = (): ReactElement => {
  const { t } = useTranslation();
  const organizationId = useOrganizationId() ?? '';

  return (
    <SectionTabsHeader
      title={t('titles.insights')}
      tabs={[
        { label: t('tabInsights'), to: insightsOverviewPath(organizationId) },
        { label: t('tabExports'), to: insightsExportsPath(organizationId) },
      ]}
    />
  );
};
